import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UnitShiftGapTagsQueryQueryCgResponse,
  UnitShiftGapTagsQueryQueryVariables,
} from '@common/graphql/schema';

export type UnitShiftGapTagType =
  UnitShiftGapTagsQueryQueryCgResponse['shiftGapTags'][number];

export const UNIT_SHIFT_GAP_TAGS_QUERY: TypedDocumentNode<
  UnitShiftGapTagsQueryQueryCgResponse,
  UnitShiftGapTagsQueryQueryVariables
> = gql`
  query UnitShiftGapTagsQuery(
    $organizationUnitId: ID!
    $includeArchived: Boolean
  ) {
    shiftGapTags(
      organizationUnitId: $organizationUnitId
      includeArchived: $includeArchived
    ) {
      id
      name
      description
      scope
      archivedAt
      organizationUnit {
        id
        name
      }
    }
  }
`;
